@if (initialized && dto) {

    <div class="mt-3">
        <bm-customer-billing-transaction-type-details
                [customerBillingTransactionTypeId]="objectIdentifier.objectId">
        </bm-customer-billing-transaction-type-details>
    </div>

}
